import { Box, Button, Switch } from '@ff-it/ui';
import cx from 'clsx';
import { type ReactElement, useState } from 'react';
import { usePermissionContext } from './context';
import type { SectionModel, SectionType } from './types';

function Model({ title, perms }: SectionModel): ReactElement {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { loading, permissions: enabledPermissions, toggle } = usePermissionContext();

  return (
    <Box mb="3">
      <Button
        active={isOpen}
        variant="secondary"
        iconAfter={`chevron-${isOpen ? 'up' : 'down'}` as any}
        style={{
          width: '100%',
          justifyContent: 'space-between',
        }}
        onClick={() => {
          setIsOpen((o) => !o);
        }}
      >
        {title}
      </Button>
      <div className={cx('collapse', { show: isOpen })}>
        <ul className="list-group">
          {perms.map(({ id, name, description }) => {
            const enabled = Boolean(enabledPermissions[id]);
            return (
              <li
                key={id}
                className="list-group-item d-flex justify-content-between align-items-start list-group-item-action px-3 py-2 borderx-0"
                onClick={(e) => {
                  toggle(id, !enabled);
                  e.preventDefault();
                }}
              >
                <div className="ms-2 me-auto">
                  <div>{name}</div>
                  {/* biome-ignore lint/security/noDangerouslySetInnerHtml: should be safe */}
                  <div className="small text-muted" dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                <Switch disabled={loading} checked={enabled} readOnly />
              </li>
            );
          })}
        </ul>
      </div>
    </Box>
  );
}

export function Section({ title, models, ...rest }: SectionType): ReactElement {
  return (
    <div className="mb-3">
      <h4>{title}</h4>
      <div className="accordion">
        {models.map((model, index) => (
          <Model {...model} key={index} {...rest} />
        ))}
      </div>
    </div>
  );
}
